import { createSystem, defaultConfig } from '@chakra-ui/react';
import { avatarSlotRecipe, dataTableSlotRecipe, statusBadgeRecipe } from '@kintsugi/ui/recipes';
// Relative: worktree may symlink root node_modules to another checkout, so
// `@kintsugi/ui/theme` would miss this branch's export. Tokens live in-repo.
import { textStyles } from '../../../../packages/ui/src/theme/tokens/typography';
import { badgeRecipe } from '../recipes/badge';
import { buttonRecipe } from '../recipes/button';
import { iconRecipe } from '../recipes/icon';
import { inputRecipe } from '../recipes/input';
import { spinnerRecipe } from '../recipes/spinner';
import { alertSlotRecipe } from '../slot-recipes/alert';
import { cardSlotRecipe } from '../slot-recipes/card';
import { checkboxSlotRecipe } from '../slot-recipes/checkbox';
import { dialogSlotRecipe } from '../slot-recipes/dialog';
import { drawerSlotRecipe } from '../slot-recipes/drawer';
import { fieldSlotRecipe } from '../slot-recipes/field';
import { nativeSelectSlotRecipe } from '../slot-recipes/native-select';
import { popoverSlotRecipe } from '../slot-recipes/popover';
import { segmentGroupSlotRecipe } from '../slot-recipes/segment-group';
import { selectSlotRecipe } from '../slot-recipes/select';
import { statusSlotRecipe } from '../slot-recipes/status';
import { tableSlotRecipe } from '../slot-recipes/table';
import { tabsSlotRecipe } from '../slot-recipes/tabs';
import { toastSlotRecipe } from '../slot-recipes/toast';
import { tooltipSlotRecipe } from '../slot-recipes/tooltip';
import { menuSlotRecipe } from '../slot-recipes/menu';

import { BORDER_WIDTHS } from './foundations/border-widths';
import { BORDERS } from './foundations/borders';
import { breakpoints } from './foundations/breakpoints';
import { colors } from './foundations/colors';
import { GRADIENTS } from './foundations/gradients';
import { RADII } from './foundations/radii';
import { SEMANTIC_TOKEN_COLORS } from './foundations/semantic-token-colors';
import { shadows } from './foundations/shadows';
import { typography } from './foundations/typography';
import { globalCss } from './styles';

export default createSystem(defaultConfig, {
  cssVarsPrefix: 'ks',
  globalCss,
  theme: {
    ...breakpoints,
    semanticTokens: {
      shadows,
      colors: SEMANTIC_TOKEN_COLORS,
    },
    // KDS Button sizes use textStyle tokens (e.g. default.medium); without these,
    // migrated buttons lose type styles and look broken.
    textStyles,
    recipes: {
      badge: badgeRecipe,
      button: buttonRecipe,
      icon: iconRecipe,
      input: inputRecipe,
      spinner: spinnerRecipe,
      statusBadge: statusBadgeRecipe,
    },
    slotRecipes: {
      alert: alertSlotRecipe,
      avatar: avatarSlotRecipe,
      card: cardSlotRecipe,
      checkbox: checkboxSlotRecipe,
      // KDS `DataTable` reads the `dataTable` key; the admin `table` recipe above
      // still drives every Chakra `Table.Root` call site.
      dataTable: dataTableSlotRecipe,
      dialog: dialogSlotRecipe,
      tooltip: tooltipSlotRecipe,
      tabs: tabsSlotRecipe,
      table: tableSlotRecipe,
      toast: toastSlotRecipe,
      popover: popoverSlotRecipe,
      segmentGroup: segmentGroupSlotRecipe,
      select: selectSlotRecipe,
      nativeSelect: nativeSelectSlotRecipe,
      field: fieldSlotRecipe,
      drawer: drawerSlotRecipe,
      status: statusSlotRecipe,
      menu: menuSlotRecipe,
    },
    tokens: {
      ...typography,
      colors,
      borders: BORDERS,
      borderWidths: BORDER_WIDTHS,
      radii: RADII,
      gradients: GRADIENTS,
    },
  },
});
